import FourOhFour from "./fourohfour"

export default  FourOhFour;
